import { actionTypeCreator, stateChangeOnlyActionTypeCreator } from '../../store/actionCreators';

export const GET_ALL_DEVICES_ACTIONTYPE = actionTypeCreator('devices/getAll');
export const GET_DEVICES_FOR_USER_ACTIONTYPE = actionTypeCreator('devices/own');
export const ADD_NEW_DEVICE_ACTIONTYPE = actionTypeCreator('devices/new');
export const UPDATE_DEVICE_ACTIONTYPE = actionTypeCreator('devices/update');
export const DELELTE_DEVICE_ACTIONTYPE = actionTypeCreator('devices/delete');
export const RESET_DEVICE_ACTIONTYPE = actionTypeCreator('devices/reset');
export const GET_DEVICE_DETAIL_ACTIONTYPE = actionTypeCreator('device/getDetail');
export const CHANGE_OWNER_ACTIONTYPE = actionTypeCreator('device/changeOwner');
export const CHANGE_OWNER_ANYDEVICE_ACTIONTYPE = actionTypeCreator('device/changeOwnerAnyDevice');
export const DELETE_OWNER_ANYDEVICE_ACTIONTYPE = actionTypeCreator('device/deleteOwner');
export const ADD_RELATIVE_ACTIONTYPE = actionTypeCreator('device/addRelative');
export const DELETE_RELATIVE_ACTIONTYPE = actionTypeCreator('device/deleteRelative');
export const HANDLE_DEVICE_SOLD_ACTIONTYPE = actionTypeCreator('device/sold');
export const GET_OWNED_DEVICE_FOR_UUID_ACTIONTYPE = actionTypeCreator('device/ownedForUuid');
export const SEND_SIGNAL_TO_WATCH_ACTIONTYPE = actionTypeCreator('device/sendSignal');
export const SET_PANIC_MODE_ACTIONTYPE = actionTypeCreator("devices/setPanicMode")
export const CLONE_DEVICE_ACTIONTYPE = actionTypeCreator("devices/cloneDevice")
export const UPDATE_DEVICE_LABEL_ACTIONTYPE = actionTypeCreator("devices/updateDeviceLabel")

export const CHANGE_SELECTED_DEVICE_ACTIONTYPE = stateChangeOnlyActionTypeCreator('devices/selected');
export const OWNED_DEVICE_CALL_SUCCESS_ACTIONTYPE = stateChangeOnlyActionTypeCreator('devices/ownedCallSuccess');
export const TRIGGER_MODESL_FETCH_FOR_ENTITY_ACTIONTYPE = stateChangeOnlyActionTypeCreator('devices/entityDialog');
export const TRIGGER_CLONE_DIALOG_FOR_DEVICE_ACITONTYPE = stateChangeOnlyActionTypeCreator('devices/cloneDeviceDialog');
export const SHOW_MONITORING_POPOVER_FOR_DEVICE_ACTIONTYPE = stateChangeOnlyActionTypeCreator(
  'device/showMonitoringPopover',
);
export const SHOW_LOCATION_POPOVER_FOR_DEVICE_ACTIONTYPE = stateChangeOnlyActionTypeCreator(
  'device/showLocationPopover',
);
export const SHOW_CONFIG_POPOVER_ACTIONTYPE = stateChangeOnlyActionTypeCreator(
  'device/showConfig',
);
